module.exports = __webpack_public_path__ + "assets/media/bolt-trio-pink.fe828639.svg";